<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        Edit
      </h5>
    </div>

    <LoadingSpinner v-if="loading"/>

    <div v-else class="panel-body form-horizontal">
      <form @submit.prevent="submit">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the project."
            :error="(errors.name || [])[0]"
        />

        <CkEditorFormGroup
            v-model="data.description"
            name="description"
            label="Description"
            help-text="The description of the project."
            :error="(errors.description || [])[0]"
        />

        <CkEditorFormGroup
            v-model="data.partner_description"
            name="partner_description"
            label="Partner Description"
            help-text="The description of the project for the partner CMS."
            :error="(errors.partner_description || [])[0]"
        />

        <RadioFormGroup
            v-model="data.is_partner_accessible"
            name="is_partner_accessible"
            label="Partner Accessible"
            help-text="Enable this option to make the project visible in the partner CMS. Disabling it will hide the project from partners."
            :error="(errors.is_partner_accessible || [])[0]"
            :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
        />

        <DateFormGroup
            v-model="data.content_deadline_at"
            name="content_deadline_at"
            label="Content Deadline"
            help-text="The content deadline for the project."
            :error="(errors.content_deadline_at || [])[0]"
        />

        <DateFormGroup
            v-model="data.ends_at"
            name="ends_at"
            label="Publish Date"
            help-text="The date the project is published."
            :error="(errors.ends_at || [])[0]"
        />

        <GalleryFormGroup
            v-model="data.partner_image_id"
            name="partner_image_id"
            label="Partner Image"
            help-text="The image for the partner CMS presentation of the project."
            :error="(errors.partner_image_id || [])[0]"
            :nullable="true"
        />

        <SelectFormGroup
            v-model="data.project_category_id"
            name="project_category_id"
            label="Project Category"
            help-text="The category of the project."
            :error="(errors.project_category_id || [])[0]"
            :options="projectCategoryOptions"
        />

        <SelectFormGroup
            v-model="data.portal_id"
            name="portal_id"
            label="Portal"
            help-text="The portal that the project belongs to."
            :error="(errors.portal_id || [])[0]"
            :options="portalOptions"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Horizontal/CkEditor'
import DateFormGroup from '@/vendor/forms/FormGroups/Horizontal/Date'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import LoadingSpinner from "../../../../components/Layout/LoadingSpinner.vue";
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import GalleryFormGroup from "../../../../components/FormGroups/Horizontal/Gallery.vue";

export default {
  components: {GalleryFormGroup, RadioFormGroup, LoadingSpinner, CkEditorFormGroup, DateFormGroup,SelectFormGroup, SubmitFormGroup, TextFormGroup},

  mixins: [Errors],

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.project.attributes},

      projectCategories: null,
      portals: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    projectCategoryOptions() {
      return this.projectCategories.map(projectCategory => ({value: projectCategory.id, label: projectCategory.attributes.name}))
    },

    portalOptions() {
      return this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
    },
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/project-categories'),
        http.get('/api/v2/portals')
      ]).then(responses => {
        this.projectCategories = responses[0].data.data

        this.portals = responses[1].data.data

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/projects/' + this.$route.params.projectId, this.data)
          .then(response => {
            notify.success('The project was saved')

            this.$emit('input', response.data.data)
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>